import { Component, OnInit, Renderer2, ViewChild, ElementRef } from '@angular/core';
// import { ROUTES } from '../../sidebar/sidebar.component';
import { Router } from '@angular/router';
import { Location} from '@angular/common';
import { AuthService } from 'app/modules/auth/_services/auth.service';

export interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}
export const ROUTES: RouteInfo[] = [
  {
    path: "/app/profile-page",
    title: "Home",
    icon: "/assets/img/Home.svg",
    class: "",
  },
  {
    path: "/app/dashboard",
    title: "Engagements",
    icon: "/assets/img/Graph.svg",
    class: "w",
  },

  {
    path: "/app/packages",
    title: "My Packages",
    icon: "/assets/img/Gift.svg",
    class: "w",
  },
  // {
  //   path: "/app/portfolio",
  //   title: "Portfolio",
  //   icon: "/assets/img/dashboard-icon.svg",
  //   class: "",
  // },
  {
    path: "/app/message",
    title: "Messages",
    icon: "/assets/img/message-icon.svg",
    class: "w",
  },
  // { path: '/app/events',           title: 'Invitte Coins',      icon:'/assets/img/coin-icon.svg',  class: 'w' },
  {
    path: "/app/profile/profile-information",
    title: "Settings",
    icon: "/assets/img/settings-icon.svg",
    class: "",
  },
];

@Component({
  moduleId: module.id,
  selector: "navbar-cmp",
  templateUrl: "navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})


export class NavbarComponent implements OnInit{
    private listTitles: any[];
    location: Location;
    private nativeElement: Node;
    private toggleButton;
    private sidebarVisible: boolean;
    mobileSidebarOpen = false;

    vendorId 

    public isCollapsed = true;
    @ViewChild("navbar-cmp", {static: false}) button;

    constructor(
      location:Location, 
      private renderer : Renderer2, 
      private element : ElementRef, 
      private router: Router,
      private authService: AuthService) {
        this.location = location;
        this.nativeElement = element.nativeElement;
        this.sidebarVisible = false;
    }
    imgURL: string;
    menuItems
    ngOnInit(){
        this.listTitles = ROUTES.filter(listTitle => listTitle);
        var navbar : HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];
        this.router.events.subscribe((event) => {
          this.sidebarClose();
       });
       this.authService.userSubject.subscribe(res => {
         if(res == undefined){
          this.user = this.authService.getUser()
          this.imgURL = this.user?.profile_picture
        } else{
          this.user = res
          this.imgURL = null
          this.imgURL = this.user?.profile_picture
         }
       })

       this.menuItems = ROUTES
    //     if (this.user?.vendorDetails?._id) {
    //   this.vendorId = this.user.vendorDetails._id;
    // } else {
    //   console.warn('Vendor ID not found on user.vendorDetails._id');
    //   // Fallback: If the user themselves is the vendor
    //   this.vendorId = this.user?._id; 
    // }
    }
   
// goTo(item: any) {
//   if (item?.path === '/app/profile-page') {
//     this.router.navigate(['/app/profile-page']);
//   } else {
//     this.router.navigate([item.path]);
//   }
// }



    user
    logout = () => this.authService.logout()
    getTitle(){
      var titlee = this.location.prepareExternalUrl(this.location.path());
      if(titlee.charAt(0) === '#'){
          titlee = titlee.slice( 1 );
      }

      for(var item = 0; item < this.listTitles.length; item++){
          if(titlee.includes(this.listTitles[item].path)){
              return this.listTitles[item].title;
          }
      }
      return 'Home'; 
    }
    mobileSidebarToggle() {
      this.mobileSidebarOpen = !this.mobileSidebarOpen;
    }
    sidebarToggle() {
        if (this.sidebarVisible === false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
      }
      sidebarOpen() {
          const toggleButton = this.toggleButton;
          const html = document.getElementsByTagName('html')[0];
          const mainPanel =  <HTMLElement>document.getElementsByClassName('main-panel')[0];
          setTimeout(function(){
              toggleButton?.classList?.add('toggled');
          }, 500);

          html.classList.add('nav-open');
          if (window.innerWidth < 991) {
            mainPanel.style.position = 'fixed';
          }
          this.sidebarVisible = true;
      };
      sidebarClose() {
          // const html = document.getElementsByTagName('html')[0];
          // const mainPanel =  <HTMLElement>document.getElementsByClassName('main-panel')[0];
          // if (window.innerWidth < 991) {
          //   setTimeout(function(){
          //     mainPanel.style.position = '';
          //   }, 500);
          // }
          // this.toggleButton.classList.remove('toggled');
          // this.sidebarVisible = false;
          // html?.classList?.remove('nav-open');
      };
      collapse(){
        this.isCollapsed = !this.isCollapsed;
        const navbar = document.getElementsByTagName('nav')[0];
        if (!this.isCollapsed) {
          navbar?.classList?.remove('navbar-transparent');
          navbar?.classList?.add('bg-white');
        }else{
          navbar?.classList?.add('navbar-transparent');
          navbar?.classList?.remove('bg-white');
        }

      }

}
